const normalizeAppUrl = (raw: string | undefined): string | undefined => {
    if (!raw) return undefined;
    return raw.replace(/^['"]|['"]$/g, '').trim();
};

/** Keycloak Valid Redirect URI whitelist ile uyumlu uygulama origin'i. */
export const getAppOrigin = (): string => {
    const appUrl = normalizeAppUrl(import.meta.env.VITE_APPURL);
    if (appUrl) {
        try {
            return new URL(appUrl).origin;
        } catch {
            // fall through
        }
    }
    return window.location.origin;
};

/** Login sonrası dönüş — ayrı /signin-oidc callback path kullanılmaz. */
export const getLoginRedirectUri = (): string => `${getAppOrigin()}/`;

/** Logout sonrası dönüş — ayrı /signout-callback-oidc path kullanılmaz. */
export const getLogoutRedirectUri = (): string => `${getAppOrigin()}/`;
